import { takeLatest, put, all, call } from 'redux-saga/effects'

import api from '~/services/api'
import { leaveOnlyNumbers } from '~/helpers/strings'
import { LOGIN_TYPES } from '~/helpers/constants'

import {
  Types,
  updateLoginData
} from './actions'

import {
  updateStores
} from '~/store/modules/store/actions'

export function * postLogin ({ payload }) {
  const { code, codeVerifier, login, password, type } = payload

  if (
    (type === LOGIN_TYPES.identity && (!code || !codeVerifier)) ||
    (type === LOGIN_TYPES.cplv && (!login || !password))
  ) yield put(updateLoginData({ error: 'Ocorreu um erro ao efetuar o login.' }))

  const loginDataError = { errorOnLogin: type }

  const { REACT_APP_BRANCH } = window?.env || {}

  const url = '/stores/employee/login?fetchStores=true'

  try {
    const response = yield call(
      api.post,
      url,
      {
        ...(code && codeVerifier ? (
          {
            code,
            codeVerifier,
            redirectUri: window.location.origin,
            unit: REACT_APP_BRANCH || 'BOT'
          }
        ) : {}),
        ...(login && password ? (
          {
            login,
            password
          }
        ) : {})
      }
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        const {
          accessToken,
          refreshToken,
          stores,
          ...loginData
        } = response.data.data[0]

        localStorage.setItem('accessToken', accessToken)
        localStorage.setItem('refreshToken', refreshToken)

        yield put(updateLoginData({
          loginData: {
            ...loginData,
            ...((login && password) ? { login_by: LOGIN_TYPES.cplv } : {}),
            ...((code && codeVerifier) ? { login_by: LOGIN_TYPES.identity } : {})
          }
        }))
        yield put(updateStores({ stores }))
      } else {
        yield put(updateLoginData({
          error: response?.data?.errors[0] || response.data.message,
          loginData: loginDataError
        }))
      }
    } else {
      yield put(updateLoginData({
        error: 'Ocorreu um erro ao efetuar o login.',
        loginData: loginDataError
      }))
    }
  } catch (error) {
    yield put(updateLoginData({
      error: error.message,
      loginData: loginDataError
    }))
  }
}

export function * mtkLogin ({ payload }) {
  const { token, storeCodes } = payload

  if (!token || !storeCodes || !storeCodes?.length) yield put(updateLoginData({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = '/impersonate/auth'

  localStorage.setItem('accessToken', token)

  try {
    const response = yield call(
      api.post,
      url,
      {
        storeCodes
      }
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        const {
          accessToken,
          refreshToken,
          stores,
          ...loginData
        } = response.data.data[0]

        localStorage.setItem('accessToken', accessToken)
        localStorage.setItem('refreshToken', refreshToken)

        yield put(updateLoginData({
          loginData: {
            ...loginData,
            ...{ login_by: LOGIN_TYPES.mktadmin }
          }
        }))
        yield put(updateStores({ stores }))
      } else {
        yield put(updateLoginData({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateLoginData({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateLoginData({ error: error.message }))
  }
}

export function * getStoresByCPF ({ payload }) {
  const { cpf } = payload

  if (!cpf) yield put(updateLoginData({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/stores/employee/${leaveOnlyNumbers(cpf)}?uniqueStores=true`

  try {
    const response = yield call(
      api.get,
      url
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        const { stores, ...loginData } = response.data.data[0]

        yield put(updateLoginData({ loginData: { ...loginData, ...{ employeeCpf: cpf } } }))
        yield put(updateStores({ stores }))
      } else {
        yield put(updateLoginData({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateLoginData({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateLoginData({ error: error.message }))
  }
}

export default all([
  takeLatest(Types.postLogin, postLogin),
  takeLatest(Types.mtkLogin, mtkLogin),
  takeLatest(Types.getStoresByCPF, getStoresByCPF)
])
